module.exports = __webpack_public_path__ + "img/choose-3.c263160c.png";